import { Uuid } from "@/domains/global/identifiers";

export enum TrashRecordingReason {
  UserDelete = "user-delete",
  RecordAgain = "record-again",
  NoteRemoved = "note-removed",
  StartRecordingFailed = "start-recording-failed",
  ActiveRecordingRecoveryFailed = "active-recording-recovery-failed",
  CreateNoteFailed = "create-note-failed",
}

export type TrashRecordingContext = {
  reason: TrashRecordingReason;
};

export interface IAudioStore {
  createAndStartAudioRecording(args: {
    audioRecordingId?: Uuid | null;
    associatedNoteId?: Uuid | null;
    associatedMeetingWindowId?: string;
    config?: {
      showOnboardingTooltip: boolean;
    };
  }): Promise<void>;
  pauseRecording(args: { audioRecordingId: Uuid }): Promise<void>;
  resumeRecording(args: { audioRecordingId: Uuid }): Promise<void>;
  finishRecording(args: { audioRecordingId: Uuid }): Promise<void>;
  trashRecording(args: { audioRecordingId: Uuid; context?: TrashRecordingContext }): Promise<void>;
  startSourceUpload(args: { audioRecordingId: Uuid; forceRestart?: boolean }): Promise<void>;
  processRecording(args: { audioRecordingId: Uuid }): Promise<void>;
  _activateRecording(args: { audioRecordingId: Uuid }): Promise<void>;
  _deactivateRecording(): Promise<void>;
}
